export default "__VITE_ASSET__DlfLWIWg__"